$(document).ready(function () {
    const formatter = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    });

    function formatDeliveryDays(deliveryDays) {
        if (!Array.isArray(deliveryDays) || deliveryDays.length === 0) {
            return '';
        }

        const firstDay = deliveryDays[0];
        const lastDay = deliveryDays[deliveryDays.length - 1];
        const dayLabel = firstDay > 1 || lastDay > 1 ? 'dias úteis' : 'dia útil';

        if (firstDay === lastDay) {
            return `${firstDay} ${dayLabel}`;
        }

        return `${firstDay} a ${lastDay} ${dayLabel}`;
    }

    // Mascara de CEP
    $('.input-cep').on('keyup change blur', function (e) {
        if ($(this).mask) {
            $(this).mask('00000-000');
        }
        if (e.type === 'blur' && $(this).val().length !== 9) {
            $(this).val("");
        }
        var cep = $(this).val();
        var cepAntes = $(this).data('val');
        if (cepAntes === cep) return;
        $(this).data('val', cep);
    });

    $('.search_zipcode').click(function (e) {
        e.preventDefault();
        var cepDestino = $('.input-cep').val().replace(/[^0-9]/, '');

        if (cepDestino.length !== 8) {
            alert("Por favor, digite um CEP válido.");
            return;
        }

        var btn = $(this);
        var originalText = btn.text();
        btn.prop('disabled', true).text("Calculando...");

        var fretesContainer = $('#simulator-shipping ul');
        var divLocalizacao = $('#simulator-shipping .sr_title');
        var textoLocalizacao = $('#simulator-shipping .sr_title span');

        fretesContainer.hide().empty().addClass('loading').show();
        divLocalizacao.hide();

        // 1. Busca endereço no ViaCEP
        $.ajax({
            url: 'https://viacep.com.br/ws/' + cepDestino + '/json/',
            dataType: 'json',
            success: function (resViaCep) {
                if (resViaCep.erro) {
                    fretesContainer.html('<li>CEP não encontrado.</li>').removeClass('loading');
                    btn.prop('disabled', false).text(originalText);
                    return;
                }

                textoLocalizacao.text(`${resViaCep.logradouro}, ${resViaCep.bairro} - ${resViaCep.localidade}/${resViaCep.uf}`);
                divLocalizacao.css('display', 'flex');

                // 2. Calcula frete via Shopify (Virtual Cart)
                calculateShopifyShipping(cepDestino, resViaCep.uf, btn, originalText, fretesContainer);
            },
            error: function () {
                // Fallback se ViaCEP falhar: Tenta calcular apenas com o CEP
                calculateShopifyShipping(cepDestino, null, btn, originalText, fretesContainer);
            }
        });
    });

    function calculateShopifyShipping(cep, uf, btn, originalText, container) {
        // Tenta pegar o ID da variante selecionada
        // 1. Procura input hidden com name='id' dentro de forms de produto
        // 2. Ou procura na select global se existir
        // 3. Verifica URL params
        let variantId = $('[name="id"]').val();
        if (!variantId || variantId === "") {
             variantId = $('#shipping-calculator-variant-id').val();
        }
        
        // Se estiver undefined, tenta pegar de um select comum no Shopify
        if (!variantId && $('.single-option-selector').length) {
             // Lógica complexa de variante, simplificando:
             // Geralmente o form updatea o [name="id"] hidden field ou o select principal tem name="id"
        }
        
        if (!variantId) {
             // Tenta pegar do objeto meta global se disponível, ou falha
             // Assumindo estrutura padrão de tema Shopify onde input[name="id"] existe
             console.warn("Variant ID não encontrado. Tentando pegar o primeiro disponível.");
        }

        // Função auxiliar para formatar resposta
        const displayRates = (rates) => {
            container.removeClass('loading').empty();
            if (rates && rates.length > 0) {
                rates.forEach(function (rate) {
                     // Formata preço (Shopify retorna em centavos string "1546" -> R$ 15,46)
                     let price = parseFloat(rate.price); 
                     const deliveryEstimate = formatDeliveryDays(rate.delivery_days);
                     
                     // Se o nome vier "Correios - SEDEX", podemos limpar
                     let name = rate.name;
                     
                     container.append(`<li>
                        <span class="ship-name">${name}</span>
                        ${deliveryEstimate ? `<span class="ship-interval">${deliveryEstimate}</span>` : ''}
                        <span class="ship-price">${formatter.format(price)}</span>
                    </li>`);
                });
            } else {
                container.html('<li>Nenhuma opção de frete encontrada para este CEP.</li>');
            }
            btn.prop('disabled', false).text(originalText);
        };

        // Verifica carrinho atual
        $.getJSON('/cart.js', function(cart) {
            const itemInCart = cart.items.find(item => item.variant_id == variantId);
            
            // Parametros para calculo
            let shippingParams = {
                shipping_address: {
                    zip: cep,
                    country: 'Brazil',
                    province: uf // Opcional, mas ajuda. Se nulo, Shopify tenta inferir.
                }
            };

            const fetchRates = () => {
                $.ajax({
                    url: '/cart/shipping_rates.json',
                    data: shippingParams,
                    dataType: 'json',
                    success: function(response) {
                        displayRates(response.shipping_rates);
                    },
                    error: function(err) {
                        console.error("Erro calcular frete shopify", err);
                         container.html('<li>Erro ao calcular frete.</li>');
                         btn.prop('disabled', false).text(originalText);
                    }
                });
            };

            if (itemInCart) {
                // Item já está no carrinho, só calcula
                fetchRates();
            } else {
                // Adiciona, calcula, remove
                $.ajax({
                    url: '/cart/add.js',
                    type: 'POST',
                    dataType: 'json',
                    data: { id: variantId, quantity: 1 },
                    success: function() {
                        // Calcula
                        $.ajax({
                            url: '/cart/shipping_rates.json',
                            data: shippingParams,
                            dataType: 'json',
                            success: function(response) {
                                displayRates(response.shipping_rates);
                                // Remove (limpa)
                                $.ajax({
                                    url: '/cart/change.js',
                                    type: 'POST',
                                    dataType: 'json',
                                    data: { id: variantId, quantity: 0 }
                                });
                            },
                            error: function(err) {
                                container.html('<li>Erro ao calcular.</li>');
                                btn.prop('disabled', false).text(originalText);
                                // Tenta remover mesmo com erro
                                $.ajax({
                                    url: '/cart/change.js',
                                    type: 'POST',
                                    dataType: 'json',
                                    data: { id: variantId, quantity: 0 }
                                });
                            }
                        });
                    },
                    error: function(err) {
                        let errorMessage = 'Selecione uma variação válida.';
                        if (err.responseJSON && err.responseJSON.description) {
                            errorMessage = err.responseJSON.description;
                        } else if (err.responseJSON && err.responseJSON.message) {
                             errorMessage = err.responseJSON.message;
                        }
                        container.html('<li>' + errorMessage + '</li>');
                        btn.prop('disabled', false).text(originalText);
                    }
                });
            }
        });
    }
});
